export enum ValueType {
  Decimal = 'decimal',
  Float = 'float',
  Float_2 = 'float_2',
  Percent = 'percent',
  Text = 'text',
  Period = 'period',
  Custom = 'custom',
  Boolean = 'boolean',
  SwitchAction = 'switchAction',
  GrowthPoint = 'growthPoint',
  Link = 'link',
  Input = 'input',
  InputText = 'text',
  InputTime = 'time',
  GrowthRate = 'growthRate',
  Tags = 'tags',
}
